module.exports = __webpack_public_path__ + "static/media/repuestos.9a8565d6.jpg";